<template>
  <keep-alive>
    <body class="animated-content infobar-overlay">
      <!-- header -->
      <head-layout></head-layout>
      <!-- header / -->
      <div id="wrapper">
        <div id="layout-static">
          <!-- Side bar -->
          <side-bar></side-bar>
          <!-- Side bar / -->

          <!-- content wrapper -->
          <div class="static-content-wrapper">
            <div class="static-content">
              <div class="page-content">
                <router-view></router-view>
              </div>
            </div>
          </div>
          <!-- Content Wrapper /-->

          <!-- Footer -->
          <div class="infobar-wrapper scroll-pane">
            <div class="infobar scroll-content">
              <div class="tab-content">
                <div class="tab-pane" id="tab-7-01">
                  <ul class="saidmenuloginAS">
                    <li>
                      <a class="withripple" href="#"
                        ><i class="material-icons">person</i> Profile</a
                      >
                    </li>
                    <li>
                      <a class="withripple" href @click.prevent="logOut"
                        ><i class="material-icons">rotate_left</i> Logout</a
                      >
                    </li>
                    <li>
                      <a class="withripple" @click="showCredentialModal = true"
                        ><i class="material-icons">lock</i> Password Reset</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Footer / -->
        </div>
      </div>
      <!-- Change Password Model -->

      <div v-if="showCredentialModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content hederpop">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close button"
                      @click="showCredentialModal = false"
                    >
                      <span aria-hidden="false">X</span>
                    </button>
                    <h4 class="modal-title">Change Password</h4>
                  </div>
                  <div class="modal-body">
                      <div class="col-xs-12">
                            <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
                                {{ SuccessMessage }}
                            </div>
                            <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
                                {{ ErrorMessage }}
                            </div>
                    </div>
                    <div class="col-xs-12">
                      <div class="form-group mb-md">
                        <div class="input-group">
                          <input
                            type="password"
                            class="form-control"
                            name="password"
                            placeholder="Password"
                            v-validate="'required|min:8|verify_password'"
                            ref="password"
                          />
                          <span v-if="errors.has('password')">
                            {{ errors.first('password') }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12">
                      <div class="form-group mb-md">
                        <div class="input-group">
                          <input
                            class="form-control"
                            placeholder="Conform Password"
                            v-model="Password"
                            v-validate="'required|confirmed:password'"
                            type="password"
                            name="password_confirmed"
                            data-vv-as="password confirmation"
                          />
                          <span v-if="errors.has('password_confirmed')">
                            {{ errors.first('password_confirmed') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" @click="ChangePasswordFunction"  class="btn btn-raised btn-primary submitbtn">Change</button>
                    <button
                      @click="showCredentialModal = false"
                      class="btn btn-cancle"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- Change Password Model -->
    </body>
  </keep-alive>
</template>
<script>
import HeadLayout from './layout_head';
import SideBar from './layout_sidebar';
import commonServices from '../../services/common-services';
export default {
  components: { HeadLayout, SideBar },
  data() {
    return {
      showCredentialModal: false,
      Password:'',
      SuccessMessage:'',
      ErrorMessage:'',
    };
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('login');
    },
    ChangePasswordFunction() {
      let loader = this.$loading.show();
      let data = {};
      
      data['Password'] = this.Password;
      commonServices
        .put('kspgAPI/User/ChangePassword', data)
        .then(
          (responce) => {
            this.SuccessMessage = responce.data.message;
          },
          (error) => {
            loader.hide();
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          if (e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          }
        });
        setTimeout(() => {loader.hide()}, 1000)
      setTimeout(() => (this.SuccessMessage = false), 5000);
      setTimeout(() => (this.ErrorMessage = false), 5000);
      setTimeout(() => (this.showCredentialModal = false), 10000);
    },
  },
  mounted() {
    let externalScript = document.createElement('script');
    externalScript.setAttribute(
      'src',
      commonServices.asset_url('assets/js/application.js')
    );
    document.head.appendChild(externalScript);
  },
};
</script>

<style scoped>
.visibility {
  visibility:visible !important;
}
#topnav {
  max-height: 64px;
  display: block;
  padding: 0;
}
.nav.navbar-nav.toolbar.pull-right {
  display: inline-block;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.close {
  color: #000 !important;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>